<div class="profile-page">
  <p class="page-title">Profiel</p>

  <div class="menu-card">
    <a class="menu-item" routerLink="/profile/gegevens">
      <div class="menu-icon-wrap">
        <mat-icon>person</mat-icon>
      </div>
      <div class="menu-content">
        <span class="menu-label">Gebruiker gegevens</span>
        <span class="menu-desc">Gebruikersnaam, familiecode en familie</span>
      </div>
      <mat-icon class="menu-arrow">chevron_right</mat-icon>
    </a>

    <div class="menu-divider"></div>

    <a class="menu-item" routerLink="/profile/instellingen">
      <div class="menu-icon-wrap">
        <mat-icon>settings</mat-icon>
      </div>
      <div class="menu-content">
        <span class="menu-label">Instellingen</span>
        <span class="menu-desc">Beta functies en overige instellingen</span>
      </div>
      <mat-icon class="menu-arrow">chevron_right</mat-icon>
    </a>

    <div class="menu-divider"></div>

    <a class="menu-item" routerLink="/profile/winkel-indeling">
      <div class="menu-icon-wrap">
        <mat-icon>storefront</mat-icon>
      </div>
      <div class="menu-content">
        <span class="menu-label">Winkel indeling</span>
        <span class="menu-desc">Winkels, categorieën en producten</span>
      </div>
      <mat-icon class="menu-arrow">chevron_right</mat-icon>
    </a>

    <div class="menu-divider"></div>

    <a class="menu-item" routerLink="/profile/mijn-lijsten">
      <div class="menu-icon-wrap">
        <mat-icon>list_alt</mat-icon>
      </div>
      <div class="menu-content">
        <span class="menu-label">Mijn lijsten</span>
        <span class="menu-desc">Boodschappen, vakantie, weekend weg…</span>
      </div>
      <mat-icon class="menu-arrow">chevron_right</mat-icon>
    </a>
  </div>
</div>
